export default __webpack_public_path__ + "static/media/HQ_bgElement.0100f6f7.png";